import React, { Component, useState } from 'react';

import { connect } from 'react-redux';
import { fetchLinkedTargets, fetchSupportedTargets } from '../redux/actions';

import Loading from './Loading';
import LoadingDial from '../components/loading/LoadingDial';
import SupportedTargetCard from '../components/targets/SupportedTargetCard';
import LinkedTargetCard from '../components/targets/LinkedTargetCard';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import ActiveGrayed from '../assets/main-logo-active.svg';

import { getLocalization } from '../redux/selectors';

const FlowTargets = (props) => {
  const { flows, linked, supported, fetchLinkedTargets, selectedFlow } = props;
  const hasLinked = linked && Object.entries(linked).length > 0;
  const [term, setTerm] = useState('');
  const localization = getLocalization();

  React.useEffect(() => {
    if (!linked) {
      fetchLinkedTargets();
    }
  }, [linked]);

  // if (flows.processingOAuth) return <Loading message="Linking Targets . . ." />;

  const linkedTargetComponents =
    linked &&
    Object.entries(linked)
      .sort(([k1, v1], [k2, v2]) => {
        if (v1.label < v2.label) return -1;
        if (v1.label > v2.label) return 1;
        return 0;
      })
      .filter(([key, value]) => !term || term.length < 1 || value.label.toLowerCase().includes(term.toLowerCase()))
      .map(([key, value]) => <LinkedTargetCard key={key} target={value} />);

  const supportedTargetComponents =
    supported &&
    linked &&
    Object.entries(supported)
      .filter(([key, value]) => linked[key] == undefined)
      .sort(([k1, v1], [k2, v2]) => {
        if (v1.label < v2.label) return -1;
        if (v1.label > v2.label) return 1;
        return 0;
      })
      .filter(([key, value]) => !term || term.length < 1 || value.label.toLowerCase().includes(term.toLowerCase()))
      .map(([key, value]) => <SupportedTargetCard key={key} target={value} hasLinked={hasLinked} />);

  const loading = !linked || !supported;

  const noTargets =
    linkedTargetComponents &&
    linkedTargetComponents.length == 0 &&
    supportedTargetComponents &&
    supportedTargetComponents.length == 0;

  const noTargetsLabel = term
    ? localization?.searchTarget?.noTargetCaption || 'No targets found with this search term.'
    : localization?.searchTarget?.noTargetAvailableCaption ||
      'No targets found. Add your first source in the admin panel!';

  const icon = selectedFlow?.flowIcon || ActiveGrayed;
  return (
    <Grid container>
      <Box position="sticky" top={0} bgcolor="background.paper" width="100%" zIndex={10000}>
        <Grid item xs={12}>
          <Box display="flex" gap={1.5}>
            <Box
              component="img"
              alt={`image for ${selectedFlow?.name} flow`}
              src={icon}
              className="img"
              width={32}
              height={32}
            />
            <Box display="flex" flexDirection="column" gap={1}>
              <Typography variant="h1">{selectedFlow?.name}</Typography>
              <Typography variant="body1">{selectedFlow?.description}</Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} mt={2} display={loading || flows.processingOAuth ? 'none' : 'flex'}>
          <TextField
            name="search"
            label={localization?.searchTarget?.searchTargetText || 'Search Target'}
            variant="standard"
            fullWidth
            onChange={(e) => setTerm(e.target.value)}
            InputProps={{
              endAdornment: <Search sx={{ color: '#ccc', fontSize: '16px' }}></Search>,
            }}
          />
        </Grid>
      </Box>
      {(loading || flows.processingOAuth) && (
        <Grid
          item
          xs={12}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(600px - 200px)' }}
        >
          <LoadingDial />
        </Grid>
      )}
      <Box
        display="grid"
        sx={{
          width: '100%',
          pt: 1,
          gap: 2,
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
          },
          '& > div:last-child': {
            mb: 2,
          },
        }}
      >
        {!loading && !flows.processingOAuth && [linkedTargetComponents, supportedTargetComponents]}
      </Box>

      {noTargets && <Typography color="text.main">{noTargetsLabel}</Typography>}
    </Grid>
  );
};

const mapStateToProps = (state, props) => {
  const flowId = state.flows.selectedFlow;
  return {
    flows: state.flows,
    selectedFlow: state.flows.supportedFlows[flowId],
    supported: state.targets.supported[flowId],
    linked: state.targets.linked,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLinkedTargets: () => dispatch(fetchLinkedTargets()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlowTargets);
